import { TextField as MUITextField } from "@mui/material";
import { Controller } from "react-hook-form";
import * as yup from "yup";

const TextField = ({ field, useFormRef, schema, label, ...props }) => {
  const { control } = useFormRef;
  const fieldSchema = schema ? yup.reach(schema, field) : null;

  return (
    <Controller
      name={field}
      control={control}
      render={({
        field: controllerField,
        fieldState: { error },
      }) => (
        <MUITextField
          fullWidth
          label={fieldSchema?.spec?.label ?? label ?? ""}
          required={!!fieldSchema?.exclusiveTests?.required}
          error={!!error}
          helperText={error?.message}
          {...controllerField}
          value={controllerField.value ?? ""}
          {...props}
        />
      )}
    />
  );
};

export default TextField;
